export const reduceArraToObjectList = (data, keyData) => {
  const aux = data.reduce((acc, d) => {
    const key = d[keyData]
    if (!acc[key]) {
      acc[key] = []
    }

    acc[key].push(d)
    return acc
  }, {})

  return aux
}
